import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "stores",
    object: "store",
    selected_id: null,
    header: [
      { text: "ID", value: "id" },
      { text: "Region Name", value: "region_id" },
      { text: "Name", value: "name" },
      { text: "Icon", value: "icon" },
      { text: "Address", value: "address" },
      // { text: "Best discount", value: "best_discount" },
      { text: "Ratings", value: "rating_actions" },
      { text: "Actions", value: "actions", sortable: false },
    ]
  },
  mutations: {
    ...genericStore.mutations,
    add_items(state, data) {
      state.selected_id = data ? data : null;
    }
  },
  actions: {
    ...genericStore.actions,
    selectItem({ commit }, item) {
      commit("add_items", item);
    }
  },
  getters: {
    ...genericStore.getters,
  },
};
